module.exports = __webpack_public_path__ + "static/media/a32.600d6e07.ogg";